import IconLoading from "./loading.svg?react";
import { twMerge } from "tailwind-merge";

export const ClipLoading = ({ className }: { className?: string }) => {
  return (
    <div className={twMerge("flex h-full w-full flex-1 items-center justify-center", className)}>
      <Loading />
    </div>
  );
};

const Loading = () => {
  return <IconLoading className="loading animate-spin"></IconLoading>;
};

export default Loading;
